
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// reactstrap components
import { FormGroup, Label, Button } from 'reactstrap';
import { useTranslate } from 'react-translate';
import { actionInviteNewPatient } from 'store/actions/analysisActions';

const AnalysisInvitePatientForm = ({ setInviteOpen }) => {
  const t = useTranslate('analysis');
  const dispatch = useDispatch();
  const loadingPatient = useSelector(state => state.analysisReducer.loadingPatientData);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [extRef, setExtRef] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const practiceId = useSelector((state) => state.userAuthorizationReducer._id);
  const emailRegex = /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gim;

  const onSubmit = () => {
    if (!lastName.length || !firstName.length || !email.length) {
        setSubmitted(true);
        return;
    }

    dispatch(actionInviteNewPatient({
      lastName: lastName,
      firstName: firstName,
      email: email,
      practice: practiceId,
      ext_ref: practiceId === "000000000000000000000201" && extRef.length ? extRef : undefined
    }));
  };

  return (
    <div>

        <FormGroup>
          <Label for="first_name">{t("first-name")}</Label>
          <input
            className={`form-control ${submitted && !firstName.length ? "has-danger" : ""}`}
            type="text"
            name="first_name"
            readOnly={loadingPatient}
            onChange={(e) => {
                setFirstName(e.target.value);
            }}
          />
          {submitted && !firstName.length && (
            <p className="alert alert-danger mt-2 w-50">{t("first-name-required")}</p>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="last_name">{t("last-name")}</Label>
          <input
            className={`form-control ${submitted && !lastName.length ? "has-danger" : ""}`}
            type="text"
            name="last_name"
            readOnly={loadingPatient}
            onChange={(e) => {
                setLastName(e.target.value);
            }}
          />
          {submitted && !lastName.length && (
            <p className="alert alert-danger mt-2 w-50">{t("last-name-required")}</p>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="email">{t("email")}</Label>
          <input
            className={`form-control ${submitted && (!email.length || !email.match(emailRegex)) ? "has-danger" : ""}`}
            type="text"
            name="email"
            readOnly={loadingPatient}
            onChange={(e) => {
                setEmail(e.target.value);
            }}
          />
          {submitted && (!email.length || !email.match(emailRegex)) && (
            <p className="alert alert-danger mt-2 w-50">
                {
                    t(!email.length ? "email-required" : "email-valid")
                }
            </p>
          )}
        </FormGroup>

        {practiceId === "000000000000000000000201" && (
          <FormGroup>
            <Label for="ext_ref">{t("ext-ref")}</Label>
            <input
              className={`form-control`}
              type="text"
              name="ext_ref"
              readOnly={loadingPatient}
              onChange={(e) => {
                  setExtRef(e.target.value);
              }}
            />
          </FormGroup>
        )}
        
        <div>
            <Button onClick={() => { onSubmit(); }} size="sm" className="btn-info">
                {t('btn-invite')}
            </Button>

            <Button onClick={() => { setInviteOpen(false) }} size="sm" className="btn-danger">
                {t('btn-cancel')}
            </Button>
        </div>
    </div>
  );
};

export default AnalysisInvitePatientForm;
